'use client';
import Hero from '@/app/contact-us/hero';
import TawkTo from '../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
import Script from "next/script"; // ✅ Import Script

function page() {
  return (
    <div>
      <title>Contact Us for Luxury Transportation | Prestige Ride</title>
      <meta
        name="description"
        content="To get your reservation done with Prestige Ride, contact our customer service team for upcoming events and make the most of it."
      />

      {/* OG Tags */}
      <meta
        property="og:url"
        content="https://www.prestigeride.com/contact-us"
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Contact Us for Luxury Transportation | Prestige Ride"
      />
      <meta
        property="og:description"
        content="To get your reservation done with Prestige Ride, contact our customer service team for upcoming events and make the most of it."
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta
        property="twitter:url"
        content="https://www.prestigeride.com/contact-us"
      />
      <meta
        name="twitter:title"
        content="Contact Us for Luxury Transportation | Prestige Ride"
      />
      <meta
        name="twitter:description"
        content="To get your reservation done with Prestige Ride, contact our customer service team for upcoming events and make the most of it."
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

<Script id="facebook-pixel" strategy="afterInteractive">
  {`
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '3940597202918092');
    fbq('track', 'PageView');
  `}
  </Script>
{/* ✅ NoScript fallback (for non-JS browsers) */}
<noscript
  dangerouslySetInnerHTML={{
    __html: `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=3940597202918092&ev=PageView&noscript=1" />
    `,
  }}
/>
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link rel="canonical" href="https://www.prestigeride.com/contact-us" />
      <TawkTo />
      <Navbar />
      <Hero />
      <Footer />
    </div>
  );
}

export default page;
